import axios from 'axios'
import Cookies from 'js-cookie'

import config from '../config'

export const getRounds = async () => {
  try {
    const res = await axios.get(`${config.apiAdminGateway}/api/v1/admin/configs/rounds`, {
      headers: { authorization: `Bearer ${Cookies.get('accessToken')}` },
    })

    const {
      status: { code, description },
      data,
    } = res.data

    if (code !== 0) {
      throw new Error(description)
    }

    return data
  } catch (err) {
    return []
  }
}

export const createRound = async (round) => {
  const res = await axios.post(
    `${config.apiAdminGateway}/api/v1/admin/configs/rounds`,
    {
      roundDate: round.toJSON(),
    },
    {
      headers: { authorization: `Bearer ${Cookies.get('accessToken')}` },
    },
  )

  const {
    status: { code, description },
  } = res.data

  if (code !== 0) {
    throw new Error(description)
  }
}
